import type {
  CircleLocale,
  LocaleBcp47,
} from "@circle-react/types/CircleLocale";

export const circleLocaleToBcp47: Record<CircleLocale, LocaleBcp47> = {
  en: "en-US",
  pt: "pt-BR",
};

export const getLocale = (locale?: CircleLocale): LocaleBcp47 => {
  if (!locale) {
    return "en-US";
  }

  return circleLocaleToBcp47[locale] || "en-US";
};

export const getCurrentCircleLocale = (): CircleLocale =>
  window?.locale ?? "en";

export const getCurrentBcp47Locale = (): LocaleBcp47 =>
  getLocale(window?.locale);

export const dynamicVariablesCorrectedTranslation = (translation: string) =>
  translation.replace(/{([\w.]+)}/g, "{{$1}}");

const pluralOrdinalRules = {
  en: new Intl.PluralRules("en-US", { type: "ordinal" }),
  pt: new Intl.PluralRules("pt-BR", { type: "ordinal" }),
};

const ordinalSuffix = {
  en: new Map([
    ["one", "st"],
    ["two", "nd"],
    ["few", "rd"],
    ["other", "th"],
  ]),
  pt: new Map([["other", "°"]]),
};

export const getOrdinal = (input: number): string => {
  const circleLocale = getCurrentCircleLocale();
  const selectPluralOrdinalRules =
    pluralOrdinalRules[circleLocale] || pluralOrdinalRules["en"];

  const rule = selectPluralOrdinalRules.select(input);
  const selectOrdinalSuffix =
    ordinalSuffix[circleLocale] || ordinalSuffix["en"];

  return `${input}${selectOrdinalSuffix.get(rule)}`;
};
